export default () => ({
  video: null,
  playing: true,
  current: "00:00:00",
  total: "00:00:00",
  percent: 0,
  inactive: false,
  ondisplaytimer: null,

  init() {
    //create video instance to use onwards
    this.video = this.$refs.video;
    //update total duration
    this.total = this.format(this.video.duration);
  },
  playpause() {
    if (!this.playing) {
      this.video.play();
      this.inactive = false;
    } else {
      this.video.pause();
    }
    this.playing = !this.playing;
  },
  timeupdate() {
    this.current = this.format(this.video.currentTime);
    this.percent = (this.video.currentTime / this.video.duration) * 100;
  },
  format(time) {
    let s = Math.floor(time % 60).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    let m = Math.floor(time / 60).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    let h = Math.floor(m / 60).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    return h + ":" + m + ":" + s;
  },
  seek(el, event) {
    let pos = event.clientX - el.getBoundingClientRect().left;
    let total = el.offsetWidth;
    let percent = pos / total;
    this.video.currentTime = percent * this.video.duration;
  },
  resetvideo() {
    // rewind video to start
    this.video.currentTime = 0;
  },
  toggleondisplay() {
    this.inactive = true;
    clearTimeout(this.ondisplaytimer);
    this.ondisplaytimer = setTimeout(() => {
      this.inactive = false;
    }, 2000);
  },
});
